<template>
  <div class="modal_delete">
    <div style="text-align: center;">
      <span class="delete"> {{ translate('notification.ask_deleted') }} </span>
    </div>
    <div class="text-center">
      <button
        type="submit"
        class="btn btn-info btn-fill btn-wd marginButton"
        @click.prevent="delete_notification"
      >
        {{ translate('yes') }}
      </button>

      <button
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('no') }}
      </button>
    </div>
  </div>

</template>
<script>

export default {
  name: "NotificationDelete",
  props: ['notice_id'],

  data () {
    return {
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    delete_notification(){
      this.$http.v1.deletetNotification({notif_id: this.notice_id},() => {
        this.global_notify('info', this.translate('notification.deleted'))
        this.$emit('reload')
        this.$emit('close')
      })
    }

  }
}

</script>

<style lang='scss'>
  .modal_delete{
    padding: 10px 0;
  }
  .marginButton {
    margin: 5px;
  }

</style>
